import _ from "lodash";

import { ITEM_CARD_NARRATIVE_LIST_VIEW } from "../../../constants/identifiers";
import { appStateSelectors } from "..";

const getFirstViewFromLayout = layout => {
  return !layout || typeof layout === "string" ? layout : getFirstViewFromLayout(layout.children.first());
};

/**
 *
 * @param {string|ViewLayoutRecord} layout
 * @param {string} targetViewId
 * @param {string} nextLayoutViewId the next viewId
 * in the same children list as the layout, used for recursive call
 */
const nextViewInLayout = (layout, targetViewId, nextLayoutViewId) => {
  if (typeof layout === "string") {
    return layout === targetViewId ? nextLayoutViewId : "";
  } else {
    // layout record
    const children = layout.children;
    let nextViewId = "";
    children.find((child, index) => {
      const nextFirstViewInChildren = getFirstViewFromLayout(children.get(index + 1));
      const nextViewInChildren = nextFirstViewInChildren ? nextFirstViewInChildren : nextLayoutViewId;
      if (child === targetViewId) {
        nextViewId = nextViewInChildren;
      } else {
        nextViewId = nextViewInLayout(child, targetViewId, nextViewInChildren);
      }
      return !_.isEmpty(nextViewId);
    });
    return nextViewId;
  }
};

const getExpandedItemKeyForMobile = globalState => {
  const viewType = appStateSelectors.getMobilePortraitViewType(globalState);
  return viewType === ITEM_CARD_NARRATIVE_LIST_VIEW ? "narrativeExpandedItems" : "sequenceExpandedItems";
};

export { getExpandedItemKeyForMobile,getFirstViewFromLayout, nextViewInLayout };
